import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./CustomDropDown.scss"; // Add your styles

const LocationDropdown = ({ location, setLocation, locationOptions }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    setLocation(option);
    setIsOpen(false);
  };

  return (
    <div className="custom-dropdown">
      <div
        className="dropdown-headerLocation"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{location || "Select Location"}</span>
        <ChevronDown size={18} />
      </div>

      {isOpen && (
        <ul className="dropdown-list">
          {locationOptions.map((option) => (
            <li key={option} onClick={() => handleSelect(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LocationDropdown;
